import React from 'react'
import { useTranslation } from 'lib/i18n'
import { RefinementListProvided } from 'react-instantsearch-core'
import { connectRefinementList } from 'react-instantsearch-dom'

import Checkbox from 'components/Filters/Checkbox'
import CheckboxList from 'components/Filters/CheckboxList'
import Hit from 'components/Filters/types/Hit'
import LocalizedRefinementItem from 'components/Filters/types/LocalizedRefinementItem'
import useLocalisedRefinementItems from 'components/Filters/useLocalisedRefinementItems'
import FilterTitle from 'components/UI/Filters/FilterTitle'
import FilterWrapper from 'components/UI/Filters/FilterWrapper'

const RATING_LEVELS = [3, 4]

const ratingFrom = (number: number): LocalizedRefinementItem => ({
  key: number.toString(),
  label: (t) =>
    t(`ratingFilter.label`, '{{number}} stars and more', { number }),
})

const byNumberDesc = (a: Hit, b: Hit) => Number(b.label) - Number(a.label)

const CustomRatingRefinementList = ({
  items,
  refine,
}: RefinementListProvided) => {
  const { t } = useTranslation()
  const { toLocalisedLabel } = useLocalisedRefinementItems(
    RATING_LEVELS.map((level) => ratingFrom(level)),
  )

  if (!items.length) {
    return null
  }

  return (
    <FilterWrapper>
      <FilterTitle title={t('filter.rating.title', 'Review rating')} />
      <CheckboxList>
        {items
          .sort(byNumberDesc)
          .map(toLocalisedLabel)
          .map((item) => (
            <Checkbox key={item.label} item={item} refine={refine} />
          ))}
      </CheckboxList>
    </FilterWrapper>
  )
}

export default connectRefinementList(CustomRatingRefinementList)
